import {useMutation} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api, {CreateServer} from 'src/services/api'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useCreateServer() {
  const {enqueueSnackbar} = useSnackbar()

  const mutation = useMutation({
    mutationFn: async (server: CreateServer) => {
      return await api.server.create(server)
    },
    onSuccess: async () => {
      enqueueSnackbar('Servidor de integração criado com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não foi possível criar o servidor no momento')
    },
  })
  return mutation
}
